{
  "workdesk.sessions": "Sessions",
  "workdesk.next": "Up next",
  "workdesk.open_panel": "Open {{panel}} panel",
  "workdesk.close_panel": "Collapse {{panel}} panel",
  "workdesk.resize_panel": "Resize {{panel}} panel",
  "workdesk.reset_layout": "Reset layout",
  "workdesk.resources": "Work resources",
  "workdesk.resume": "Resume",
  "workdesk.notes": "Notes",
  "workdesk.maps": "Maps"
}
